import { createContext, useEffect, useState } from 'react'

interface MiniAppProviderProps {
    children: JSX.Element
}

interface MiniAppContextProps {
    isMiniApp: boolean
    telegramWebApp: any
    canAddAtHomeScreen: boolean
}

export const MiniAppContext = createContext<MiniAppContextProps | null>(null)

export const MiniAppProvider = ({ children }: MiniAppProviderProps) => {
    const [canAddAtHomeScreen, setCanAddAtHomeScreen] = useState(false)

    const webApp = window.Telegram.WebApp

    webApp.disableVerticalSwipes()
    webApp.ready()
    webApp.expand()

    useEffect(() => {
        if (!webApp || !webApp.isVersionAtLeast('8.0')) return

        webApp.checkHomeScreenStatus((value) => {
            if (value === 'unknown' || value === 'missed') {
                setCanAddAtHomeScreen(true)
            }
        })
    }, [webApp])

    return (
        <MiniAppContext.Provider
            value={{
                isMiniApp: webApp?.initData !== '' && webApp?.platform !== 'unknown',
                telegramWebApp: webApp,
                canAddAtHomeScreen
            }}
        >
            {children}
        </MiniAppContext.Provider>
    )
}
